import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import { FeatureFlags } from '@/plugins/featureFlags'

export const usePageTitle = (): void => {
  const { t } = useI18n()

  const route = useRoute()

  const getTitleKey = (): string => {
    const matches = route.matched

    for (let i = matches.length - 1; i > 0; i--) {
      const match = matches[i]
      if (match?.meta?.title) {
        // Feedback → Guest Support rename gated on inbox_order_support_rename
        if (
          match.name === 'brand.feedback' &&
          FeatureFlags.isEnabled('inbox_order_support_rename')
        ) {
          return 'restaurant.customer-support'
        }
        return match.meta.title
      }
    }

    return 'fallback'
  }

  watch(route, () => {
    document.title = `Owner.com | ${t(`core.pages.${getTitleKey()}.title`)}`
  })
}
